export default __webpack_public_path__ + "static/media/heading.8aa3ac77.jpg";